import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL5 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Ayo Oke Joins Denver Summit FC",
            author: "footballgirl",
              date: "January, 2026",
            image: "images/nwsl/5a.jpg",
            content: `<h2>Denver Summit FC Bolsters Defense with Transfer of Rising Star Ayo Oke from Pachuca</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>

<p><strong>Denver Summit FC</strong>, the National Women's Soccer League's (NWSL) newest expansion franchise set to debut in the 2026 season, has strengthened its inaugural roster by securing U.S. youth international defender <strong>Ayo Oke</strong> via a transfer from CF Pachuca of Liga MX Femenil.</p>

<p>The move, officially announced on January 6, 2026, marks a significant investment by the Colorado-based club. Reports indicate that Denver Summit FC paid a transfer fee close to $450,000 to acquire Oke, which would represent the highest incoming transfer fee ever paid for an American player in NWSL history.</p>

<p>Oke, a 22-year-old right back (born April 5, 2003), hails from Georgia and brings a wealth of recent professional experience despite her young age. She began her pro career in January 2025 with Pachuca after starring in college soccer for the California Golden Bears and UCLA Bruins. In her debut season south of the border, Oke made 31 appearances across all competitions, contributing to Pachuca's success—including their 2025 Clausura playoff title win. The club also finished second in the 2025 Apertura regular season standings.</p>

<p>Denver Summit FC's General Manager Curt Johnson praised the addition, describing Oke as "a modern defender with exceptional athleticism, technical quality, and a high soccer IQ." Oke herself expressed enthusiasm about the move, stating, “I’m excited to join Denver Summit FC and be part of building something new.”</p>

<p>The transfer aligns with the club's strategy to assemble a competitive squad ahead of their first campaign. Oke joins a growing defensive unit that includes established names such as Carson Pickett, Camryn Biegalski, Kaleigh Kurtz, and Megan Reid. As the fifth defender signed by the expansion side, she is expected to provide versatility and depth on the right flank.</p>

<p>Oke's arrival has quickly paid dividends beyond the club level. Shortly after the transfer, she earned her first senior call-up to the U.S. Women's National Team under head coach Emma Hayes, replacing Avery Patterson on the January training camp roster for matches against Paraguay and Chile. She has been a regular with the USWNT U-23 squad in recent camps and has spoken about her surprise and excitement at the senior opportunity.</p>

<p>Denver Summit FC, officially awarded as the NWSL's 16th team in January 2025 and named in July 2025, will play home games at venues including Empower Field at Mile High for their opener. The club has generated strong local interest, with ticket sales surpassing 45,000 ahead of the season and initiatives to inspire young players across Colorado.</p>

<p>This high-profile signing underscores Denver's ambition to compete immediately in the league while highlighting the growing global pathways for American talent, as Oke returns from a successful stint abroad to join one of the NWSL's newest chapters.</p>

<p>The team kicks off its inaugural season soon, with fans eager to see how Oke and the rest of the roster perform in the Mountains.</p> <h1>丹佛峰会足球俱乐部通过从帕丘卡转会引进新星后卫阿约·奥克加强防线</h1>

<p><b>丹佛峰会足球俱乐部</b>（Denver Summit FC），美国女子职业足球联赛（NWSL）最新的扩军球队，将于2026赛季正式亮相，通过从墨西哥女子甲级联赛（Liga MX Femenil）的CF帕丘卡转会，成功签下美国青年国脚后卫<b>阿约·奥克</b>（Ayo Oke），进一步强化了球队的首发阵容。</p>

<p>此次转会于2026年1月6日正式宣布，标志着这支科罗拉多州球队做出了重大投资。据报道，丹佛峰会足球俱乐部向帕丘卡支付了接近45万美元的转会费，这将成为NWSL历史上为美国球员支付的最高转会费纪录。</p>

<p>奥克是一位22岁的右后卫（出生于2003年4月5日），来自佐治亚州，尽管年纪轻轻，却已积累了丰富的职业经验。她在加州大学伯克利分校金熊队和加州大学洛杉矶分校布鲁因队表现出色后，于2025年1月与帕丘卡签订了首份职业合同。在墨西哥的首个赛季，她在各项赛事中出场31次，帮助帕丘卡赢得2025年克劳苏拉季后赛冠军，并在2025年阿佩图拉常规赛中获得第二名。</p>

<p>丹佛峰会足球俱乐部总经理柯特·约翰逊（Curt Johnson）高度评价这次引援，称奥克是“一位现代型后卫，拥有出色的运动能力、技术水准和高足球智商”。奥克本人对转会也表达了兴奋之情：“我很高兴加入丹佛峰会足球俱乐部，参与打造一支全新的球队。”</p>

<p>此次转会符合俱乐部在首个赛季前组建竞争力阵容的战略。奥克加入了一支不断壮大的后防线，包括卡森·皮克特（Carson Pickett）、卡姆琳·比加尔斯基（Camryn Biegalski）、凯莉·库尔茨（Kaleigh Kurtz）和梅根·里德（Megan Reid）等知名球员。作为球队签下的第五位后卫，她预计将在右路提供多功能性和深度。</p>

<p>奥克的到来迅速在俱乐部层面之外产生积极影响。转会后不久，她便首次入选美国女子国家队，在主教练艾玛·海耶斯（Emma Hayes）的征召下，顶替因病缺席的艾弗里·帕特森（Avery Patterson），参加了1月份对阵巴拉圭和智利的训练营。她近期一直是美国U23女足国家队的常客，并对这次高级国家队机会感到惊喜和激动。</p>

<p>丹佛峰会足球俱乐部于2025年1月被正式授予NWSL第16支球队资格，并于2025年7月公布队名。球队将在包括Mile High Empower Field在内的场地进行主场比赛，包括揭幕战。俱乐部已引发强烈本地关注，赛季前门票销量已超过4.5万张，并推出多项激励科罗拉多州年轻球员的举措。</p>

<p>这次高调引援凸显了丹佛立即在联赛中具备竞争力的雄心，同时也展示了美国人才日益增长的全球流动路径——奥克在海外成功效力后回归，加入NWSL最新篇章之一。</p>

<p>球队即将开启首个赛季，球迷们热切期待看到奥克与队友们在落基山脉地区的精彩表现。</p>`,
                     tags: ["NWSL", "Denver Summit FC", "Ayo Oke", "Transfers", "Pachuca", "USWNT"],  
navIndices: { prev: 'nwsl-4', next: 'nwsl-6' }
        });
    }

    init() {
        console.log('ArticlePageNWSL5 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}